import { Link } from "react-router-dom";
import { site } from "@/mocks/site";

export default function ContactBanner() {
  return (
    <section className="relative w-full overflow-hidden rounded-lg bg-primary-950">
      <div className="absolute inset-0 opacity-30">
        <img
          src="https://readdy.ai/api/search-image?query=flat%20vector%20illustration%20of%20colorful%20speech%20bubbles%20and%20sticker%20faces%20drifting%20across%20a%20deep%20warm%20background%20with%20soft%20glow%2C%20coral%20orange%20golden%20yellow%20and%20cream%20accents%2C%20bold%20rounded%20shapes%2C%20clean%20poster%20composition%2C%20high%20detail%2C%20no%20text&width=1400&height=700&seq=wg-cta-01&orientation=landscape"
          alt="网爆吃瓜投稿与联系"
          title="网爆吃瓜 投稿 联系"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="relative px-6 py-12 md:px-12 md:py-16 grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
        <div>
          <span className="section-eyebrow text-accent-400">投稿 · 合作 · 内容反馈</span>
          <h2 className="mt-3 text-2xl md:text-4xl text-background-50 text-balance">
            有更好笑的瓜？来，我们缺你这一口
          </h2>
          <p className="mt-4 text-sm md:text-base text-background-200 leading-relaxed max-w-lg">
            表情包、段子、神回复、梗图或二创视频都可以投稿，被采纳的内容会署名展示，还能进入对应频道的推荐位。
          </p>
        </div>
        <div className="flex flex-col gap-4 lg:items-end">
          <Link
            to="/about#submit"
            className="inline-flex items-center justify-center gap-2 h-12 px-7 rounded-md bg-accent-500 text-accent-950 text-sm hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-send-plane-line"></i>
            </span>
            填写投稿表单
          </Link>
          <a
            href={`mailto:${site.email}`}
            className="inline-flex items-center justify-center gap-2 h-12 px-7 rounded-md border border-background-50/30 text-background-50 text-sm hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
          >
            <span className="w-4 h-4 flex items-center justify-center">
              <i className="ri-mail-line"></i>
            </span>
            {site.email}
          </a>
          <p className="text-xs text-background-400 lg:text-right">{site.updateTime}</p>
        </div>
      </div>
    </section>
  );
}